/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PersonType {
    NATURAL = 'NATURAL',
    LEGAL = 'LEGAL',
}
